//리뷰 layer
var reviewLayer = {
    loginUrl: "/sso/member/login",  //로그인 url
    prefixReviewUrl : "/mkt/review/",       //리뷰 화면 prefix
    prefixReviewApiUrl : "/mkt/api/review/",    //리뷰 api prefix
    reviewLayerArea : null, //리뷰 영역
    init:function(){
        //BTOCSITE-77514 > WA 전문가점검 > 6. 리뷰보기 -> 닫기 -> 초점 초기화
        var $focusReviewBtn = null;
        $('[onclick="javascript:reviewLayer.reviewLayer(this)"]').on('click',function(e){
            $focusReviewBtn = $(this);
        });
        $(window).on('modalhidden',function(e){
            if(e.target.id=='reviewLayer'){
                setTimeout(function(){
                    $focusReviewBtn != null && $focusReviewBtn.focus();
                    $focusReviewBtn = null;
                },300);
            }
        });

        // console.log("=============> reviewLayer.js init");
        reviewLayer.reviewLayerArea = $("#reviewLayerArea");
        // if($("#reviewPhotoVideoLayer")){
        //     reviewLayer.reviewPhotoVideoLayerCall($("#reviewPhotoVideoLayer").get(0));
        // }
        if($("#preloadReviewImageVideo").length > 0){
            reviewLayer.preloadReviewPhotoVideo($("#preloadReviewImageVideo").get(0));
        }
    },
    getUrl: function (call, modelId) {
        return reviewLayer.prefixReviewUrl + modelId + "/" + call;
    },
    callAjax:function(callParam,param,callback){
        var type = callParam.type ? callParam.type : "POST";
        var contentType = callParam.contentType ? callParam.contentType : "application/json; charset=UTF-8;";
        var enctype = callParam.enctype ? callParam.enctype : "";
        var processData = callParam.processData ? callParam.processData : "";
        var async = callParam.async ? callParam.async : true;
        var isLoading = callParam.isLoading && callParam.isLoading == 'N' ? false : true;
        var cache = callParam.cache ? callParam.cache : true;
        if(isLoading){
            lgkorUI.showLoading();
        }
        $.ajax({
            url: callParam.url,
            type: type,
            data: param,
            contentType: contentType,
            enctype : enctype,
            processData : processData,
            async : async,
            cache : cache,
            success: function (data) {
                if (typeof callback == 'function') {
                    callback(data);
                }
                if(isLoading) {
                    lgkorUI.hideLoading();
                }
            },
            error: function (e) {
                console.log(e);
                if(isLoading) {
                    lgkorUI.hideLoading();
                }
            }
        });
    },
    goPage:function(url){
        location.href = url;
    },
    //베스트,포토동영상,베스트샵 layer
    reviewLayer: function (obj) {
        if($("#reviewLayer") && $("#reviewLayer").html().length > 0){
            // console.log("reviewLayer exists!!!");
            $("#reviewLayer").vcModal('close');
        }
        $("#reviewLayer").empty();
        var url = reviewLayer.getUrl("reviewLayer", obj.dataset.modelId);
        var param = {};
        var viewType = obj.dataset.viewType ? obj.dataset.viewType : "";
        if(viewType == 'normal'){
            if(review.realSearchParam){
                param = review.realSearchParam;
            }
        }
        param.viewType = viewType;
        var initialIndex = obj.dataset.initialIndex ? obj.dataset.initialIndex : '1';
        param.initialIndex = initialIndex;

        if (obj.dataset.reviewId && obj.dataset.reviewId != "") {
            param.searchReviewId = obj.dataset.reviewId;
        }
        param.mobile = vcui.detect.isMobile;

        var viewType = param.viewType;
        var modelId = obj.dataset.modelId;
        var searchReviewId = param.searchReviewId;

        param.modelDisplayname = obj.dataset.modelDisplayname ? obj.dataset.modelDisplayname : "";
        var modelDisplayname = param.modelDisplayname; //BTOCSITE-77514 [웹앱 접근성 개선활동] 상품(보유제품)_마이페이지>보유제품/리뷰 : alt 에 상품명 노출

            reviewLayer.callAjax({
            url: url,
            isLoading : 'N'
        },JSON.stringify(param),function(data){
            //BTOCSITE-77514 웹접근성
            data = data.replace(/<video/g,'<video tabindex="-1"');

            $("#reviewLayer").html(data);
            reviewLayer.setMobileLayerEvent({
                modelId : modelId,
                viewType : viewType,
                searchReviewId : searchReviewId,
                modelDisplayname : modelDisplayname
            });
            var modal = $("#reviewLayer").vcModal();
            //BTOCSITE-81509 웹접근성
            setTimeout(function(){
                $('#reviewLayer .ui_tooltip-target').vcTooltipTarget();
            },1200);  
            setTimeout(function(){
                if($('.ui_modal_dim').length > 1){
                    $($('.ui_modal_dim').get(1)).hide();
                }
            },100);
        });
    },
    setMobileLayerEvent:function(param){
        // swiper chanage 때마다 호출됨
        if(vcui.detect.isMobile == true){
            var initPageIdx = $("#reviewLayerArea").get(0).dataset.initPageIdx;
            $('.ui_review_slider').on('call', function (e, data, callback) {
                // console.log('call', data);
                // console.log(param);
                if(param.viewType == 'myreview'){
                    param.pageIdx = 1;
                    reviewLayer.getReviewModule(param,data.currentElms[0],callback);
                }else{
                    var totalCount = Number($("#reviewLayerArea").get(0).dataset.reviewCount);

                    // console.log(data.currentElms);
                    // console.log(data.prevElms);
                    // console.log(data.nextElms);
                    var curPageIdx = data.currentIdx + 1;
                    // var curElms = $(data.currentElms[0]);
                    // console.log(curElms.find('.pop-review-wrap'));

                    // if(curElms.find('.pop-review-wrap').length > 0){
                    //     curPageIdx = curElms.find('.pop-review-wrap').get(0).dataset.pageIdx;
                    // }else{
                    //     curPageIdx = Number(initPageIdx);
                    //     param.pageIdx = curPageIdx;
                    //     reviewLayer.getReviewModule(param,data.currentElms[0],callback);
                    // }
                    param.pageIdx = curPageIdx;
                    reviewLayer.getReviewModule(param,data.currentElms[0],callback);

                    var next = Number(curPageIdx) + 1;
                    if(next > totalCount){
                        next = next - totalCount;
                    }
                    var pre = Number(curPageIdx) - 1;
                    if(pre < 1){
                        pre = totalCount + pre;
                    }
                    //idx -2, +2 review call
                    param.pageIdx = pre;
                    reviewLayer.getReviewModule(param,data.prevElms[0]);
                    param.pageIdx = next;
                    reviewLayer.getReviewModule(param,data.nextElms[0]);
                }

                callback();
            });
        }
    },
    preloadReviewPhotoVideo : function(obj){
        var url = reviewLayer.getUrl("preloadReviewPhotoVideo", obj.dataset.modelId);
        var param = {}
        var orgViewType = obj.dataset.orgViewType ? obj.dataset.orgViewType : "";
        param.orgViewType = orgViewType;

        reviewLayer.callAjax({
            url: url,
            isLoading : 'N'
        },JSON.stringify(param),function(data){
            $("#preloadReviewImageVideo").html(data);
        });
    },
    reviewPhotoVideoLayerCall : function(obj,callback){
        var url = reviewLayer.getUrl("reviewPhotoVideoLayer", obj.dataset.modelId);
        var param = {}
        var orgViewType = obj.dataset.orgViewType ? obj.dataset.orgViewType : "";
        if(orgViewType == 'normal'){
            if(review.realSearchParam){
                param = review.realSearchParam;
            }
        }
        param.orgViewType = orgViewType;

        if (obj.dataset.reviewId && obj.dataset.reviewId != "") {
            param.searchReviewId = obj.dataset.reviewId;
        }

        reviewLayer.callAjax({
            url: url,
            isLoading : 'N'
        },JSON.stringify(param),function(data){
            $("#reviewPhotoVideoLayer").html(data);
        });
    },
    //포토/동영상 전체보기 layer
    reviewPhotoVideoLayer: function (obj) {
        // if($("#reviewLayer") && $("#reviewLayer").html().length > 0){
        //     if($("#reviewLayer").parent().hasClass('ui_modal_wrap')){
        //         $("#reviewLayer").vcModal('close');
        //     }
        // }
        // if($("#reviewPhotoVideoLayer").html().length > 0){
        //     $("#reviewPhotoVideoLayer").vcModal();
        //     setTimeout(function(){
        //         if($('.ui_modal_dim').length > 1){
        //             $($('.ui_modal_dim').get(1)).hide();
        //         }
        //     },100);
        // }else{
        //     reviewLayer.reviewPhotoVideoLayerCall(obj,function(){
        //         $("#reviewPhotoVideoLayer").vcModal();
        //         setTimeout(function(){
        //             if($('.ui_modal_dim').length > 1){
        //                 $($('.ui_modal_dim').get(1)).hide();
        //             }
        //         },100);
        //     });
        // }
        if($("#reviewLayer") && $("#reviewLayer").html().length > 0){
            if($("#reviewLayer").parent().hasClass('ui_modal_wrap')){
                $("#reviewLayer").vcModal('close');
            }
        }
        $("#reviewPhotoVideoLayer").empty();
        var url = reviewLayer.getUrl("reviewPhotoVideoLayer", obj.dataset.modelId);
        var param = {}
        var orgViewType = obj.dataset.orgViewType ? obj.dataset.orgViewType : "";
        if(orgViewType == 'normal'){
            if(review.realSearchParam){
                param = review.realSearchParam;
            }
        }
        param.orgViewType = orgViewType;

        if (obj.dataset.reviewId && obj.dataset.reviewId != "") {
            param.searchReviewId = obj.dataset.reviewId;
        }

        reviewLayer.callAjax({
            url: url,
            isLoading : 'N'
        },JSON.stringify(param),function(data){
            $("#reviewPhotoVideoLayer").html(data);
            var modal = $("#reviewPhotoVideoLayer").vcModal();
            setTimeout(function(){
                if($('.ui_modal_dim').length > 1){
                    $($('.ui_modal_dim').get(1)).hide();
                }
            },100);

        });
    },
    //리뷰 목록조회
    getReviewList: function(obj){
        var url = reviewLayer.getUrl("reviewLayer", obj.dataset.modelId);
        var param = {};
        var viewType = obj.dataset.viewType ? obj.dataset.viewType : "";
        if(viewType == 'normal'){
            if(review.realSearchParam){
                param = review.realSearchParam;
            }
            param.searchReviewId = "";  //page 이동시 초기화
        }
        param.viewType = viewType;

        if (obj.dataset.pageIdx && obj.dataset.pageIdx != "") {
            param.pageIdx = obj.dataset.pageIdx;
        }

        reviewLayer.callAjax({
            url: url
        },JSON.stringify(param),function(data){
            $("#reviewLayer").html(data);
        });
    },
    removeReviewModule : function(param){
        var totalCount = Number($("#reviewLayerArea").get(0).dataset.reviewCount);
        var curPageIdx = param.currentIdx + 1;
        var deleteTerm = 4

        if(totalCount > deleteTerm + 2){

            var next = Number(curPageIdx) + deleteTerm;
            if(next > totalCount){
                next = next - totalCount;
            }
            // console.log("removeReviewModule.....next : ",next);
            var nextReviewModuleArea = $("div[data-id='review_"+next+"']");
            nextReviewModuleArea.empty();
            $.each(nextReviewModuleArea,function(idx,el){
                // console.log(el);
                $(el).empty();
            })

            var pre = Number(curPageIdx) - deleteTerm;
            if(pre < 1){
                pre = totalCount + pre;
            }
            // console.log("removeReviewModule.....pre : ",pre);
            var preReviewModuleArea = $("div[data-id='review_"+pre+"']");
            $.each(preReviewModuleArea,function(idx,el){
                // console.log(el);
                $(el).empty();
            })
        }
    },
    //리뷰 모듈 조회
    getReviewModule: function(data,swiperArea,callback){
        // console.log(swiperArea);
        // console.log(data);
        var reviewModuleArea = $(swiperArea);
        var pageIdx = data.pageIdx;
        var load = false;

        if(reviewModuleArea.find(".pop-review-wrap").length == 0){
            load = true;
        }
        if(load){
            var url = reviewLayer.getUrl("reviewLayerModule", data.modelId);
            var param = {};
            var viewType = data.viewType ? data.viewType : "";
            if(viewType == 'normal'){
                if(review.realSearchParam) {
                    param = review.realSearchParam;
                }
                param.searchReviewId = "";  //page 이동시 초기화
            }
            param.viewType = viewType;
            param.pageIdx = data.pageIdx;
            param.mobile = vcui.detect.isMobile;
            param.modelDisplayname = data.modelDisplayname;

            if(data.viewType == 'myreview'){
                param.searchReviewId = data.searchReviewId;
            }

            reviewLayer.callAjax({
                url: url,
                isLoading : "N"
            },JSON.stringify(param),function(data){
                reviewModuleArea.html(data);

                if(typeof callback == 'function'){
                    callback();
                }
            });
        }
    },
    //추천
    saveRecommand: function (obj) {
        var param = {
            reviewId: obj.dataset.reviewId,
            useFlag: (obj.dataset.recommandOwnCount > 0) ? "N" : "Y"
        };

        reviewLayer.callAjax({
                url : reviewLayer.prefixReviewApiUrl+"saveRecommand"
            },
            JSON.stringify(param),
            function(data){
                // console.log(data);
                if (data.resultCode == "SUCCESS") {
                    var recommand = data.reviewRecommand;
                    obj.dataset.recommandCount = recommand.recommandCount;
                    $(obj).parent().find(".count").html(recommand.recommandCount);
                    if (param.useFlag == "N") {
                        obj.dataset.recommandOwnCount = 0;
                        $(obj).parent().removeClass("on");
                    } else {
                        obj.dataset.recommandOwnCount = 1;
                        $(obj).parent().addClass("on");
                    }
                } else if (data.resultCode == "NOT_LOGIN") {
                    lgkorUI.confirm("로그인 후 추천이 가능합니다.<br>로그인 하시겠습니까? ", {
                        title: "",
                        cancelBtnName: "아니요",
                        okBtnName: "네",
                        ok:function(){
                            reviewLayer.goPage(reviewLayer.loginUrl);
                        }
                    });
                }
            }
        );
    },
    declairForm: function (e) {
        var reviewId = e.dataset.reviewId;
        if(!vcui.isEmpty(reviewId)){
            reviewPopup.reviewDeclairFormPopup({
                reviewId :  reviewId,
            });
        }
    }
}
$(function(){
    reviewLayer.init();
});
